import { List, ListItem } from "@mui/material";
import { memo, useCallback } from "react";

import { useQueryParams } from "../../../../../hooks/useQueryParams";

import DatePickerFilter from "./components/DatePickerFilter";
import DateRange from "./components/DateRange";
import MultiSelectSearch from "./components/MultiSelectSearch";
import RangeSlider from "./components/RangeSlider";
import SearchOptionGroup from "./components/SearchOptionGroup";
import SingleSelect from "./components/SingleSelect";

const FiltersList = ({ filterState }) => {
  const { updateFilter, bulkUpdateFilters } = useQueryParams();

  const renderFilterUI = useCallback(
    (element) => {
      const currentFilterState = filterState.find((f) => f.fieldName === element.fieldName);

      if (!currentFilterState) {
        return null;
      }

      switch (element.filterType) {
        case "RangeSlider":
          return (
            <RangeSlider
              bulkUpdateFilters={bulkUpdateFilters}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              maxValue={currentFilterState.currentValue?.__lte}
              minValue={currentFilterState.currentValue?.__gte}
              title={currentFilterState.title}
            />
          );
        case "MultiSelectSearch":
          return (
            <MultiSelectSearch
              apiUrl={currentFilterState.apiUrl}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              nameKey={currentFilterState.nameKey}
              orderingVal={currentFilterState.orderingVal}
              searchTitle={currentFilterState.searchTitle}
              selectedItems={currentFilterState.currentValue || []}
              title={currentFilterState.title}
              updateFilter={updateFilter}
              valueKey={currentFilterState.valueKey}
              noShowMore={currentFilterState?.noShowMore ?? false}
            />
          );
        case "SingleSelect":
          return (
            <SingleSelect
              apiUrl={currentFilterState.apiUrl}
              currentValue={currentFilterState.currentValue}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              nameKey={currentFilterState.nameKey}
              orderingVal={currentFilterState.orderingVal}
              title={currentFilterState.title}
              updateFilter={updateFilter}
              valueKey={currentFilterState.valueKey}
            />
          );
        case "SearchOptionGroup":
          return (
            <SearchOptionGroup
              currentValue={currentFilterState.currentValue}
              customFalseLabel={currentFilterState.customFalseLabel}
              customTrueLabel={currentFilterState.customTrueLabel}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              title={currentFilterState.title}
              updateFilter={updateFilter}
              hideFalseLabel={currentFilterState?.hideFalseLabel ?? false}
            />
          );
        case "DatePicker":
          return (
            <DatePickerFilter
              currentValue={currentFilterState.currentValue}
              fieldName={currentFilterState.fieldName}
              title={currentFilterState.title}
              updateFilter={updateFilter}
            />
          );
        case "DateRange":
          return (
            <DateRange
              dateFrom={currentFilterState.currentValue?.__gte}
              dateTo={currentFilterState.currentValue?.__lte}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              title={currentFilterState.title}
              updateFilter={updateFilter}
            />
          );
        default:
          return null;
      }
    },
    [filterState]
  );

  const renderFilterList = useCallback(
    () => (
      <List>
        {filterState.map((filterConfig) => (
          <ListItem key={filterConfig.fieldName}>{renderFilterUI(filterConfig)}</ListItem>
        ))}
      </List>
    ),
    [filterState, renderFilterUI]
  );

  return <div className="h-full overflow-y-auto">{renderFilterList()}</div>;
};

export default memo(FiltersList);
